<div class="order-confirmation-container">
    <div *ngIf="answerToCreateOrderRequest?.customerOrderReference!==null" class="order-status">
        <h3>{{"shoppingCart.thanksForOrder" | translate }}</h3>
        <h3>{{"shoppingCart.sentAnEmail" | translate }}</h3>
        <h3>{{"shoppingCart.orderId" | translate }}: {{answerToCreateOrderRequest?.customerOrderReference}}</h3>
        <h3>{{"shoppingCart.totalPrice" | translate }}: {{totalPrice | currency : 'Ft' : 'symbol' : '1.0-0'}}</h3>
    </div>
</div>
